import { initializeApp } from "firebase/app";

//  const config = {
//  apiKey: process.env.REACT_APP_API_KEY,
//  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//  projectId: process.env.REACT_APP_PROJECT_ID,
//  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//  appId: process.env.REACT_APP_APP_ID,
//  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
// };
const firebaseConfig = {
  apiKey: "AIzaSyAGDnk9sYkHRFXCiWVdo_D1tMGd_SW4woI",
  authDomain: "landing-pages-3185c.firebaseapp.com",
  databaseURL: "https://landing-pages-3185c-default-rtdb.firebaseio.com",
  projectId: "landing-pages-3185c",
  storageBucket: "landing-pages-3185c.firebasestorage.app",
  messagingSenderId: "907524008170",
  appId: "1:907524008170:web:738a7a1a12427b201e0f93",
  measurementId: "G-PEM18DEQ05"
};
 
const cong = initializeApp(firebaseConfig);

export default cong;